<script>
export default {
  props: {
    module: {
      type: Object,
    },
  },
};
</script>
<template>
  <div class="wrap">
    <FBody
      :module="module"
    >
      <RowSpan>
        <ColSpan
          span="3"
        >
          <FItem
            :module="module.getItem('dateStart')"
          />
        </ColSpan>
        <ColSpan
          span="3"
        >
          <FItem
            :module="module.getItem('dateEnd')"
          />
        </ColSpan>
        <ColSpan
          span="3"
        >
          <FItem
            :module="module.getItem('numberAgreement')"
          />
        </ColSpan>
        <ColSpan
          span="3"
        >
          <FItem
            :module="module.getItem('statusAgreement')"
          />
        </ColSpan>
      </RowSpan>
      <RowSpan>
        <ColSpan
          span="3"
        >
          <FItem
            :module="module.getItem('country')"
          />
        </ColSpan>
        <ColSpan
          span="3"
        >
          <FItem
            :module="module.getItem('city')"
          />
        </ColSpan>
        <ColSpan
          span="3"
        >
          <FItem
            :module="module.getItem('fioTourist')"
          />
        </ColSpan>
        <ColSpan
          span="3"
        >
          <FItem
            :module="module.getItem('nameTour')"
          />
        </ColSpan>
      </RowSpan>
      <RowSpan>
        <ColSpan
          span="3"
        >
          <FItem
            :module="module.getItem('partner')"
          />
        </ColSpan>
        <ColSpan
          span="3"
        >
          <FItem
            :module="module.getItem('department')"
          />
        </ColSpan>
        <ColSpan
          span="3"
        >
          <FItem
            :module="module.getItem('manager')"
          />
        </ColSpan>
        <ColSpan
          span="3"
        >
          <FItem
            :module="module.getItem('dateCreate')"
          />
        </ColSpan>
      </RowSpan>
      <RowSpan>
        <ColSpan
          span="3"
        >
          <FItem
            :module="module.getItem('priceForTourist')"
          />
        </ColSpan>
        <ColSpan
          span="3"
        >
          <FItem
            :module="module.getItem('priceForAgency')"
          />
        </ColSpan>
        <ColSpan
          span="3"
        >
          <FItem
            :module="module.getItem('price')"
          />
        </ColSpan>
        <ColSpan
          span="3"
        >
          <FItem
            :module="module.getItem('days')"
          />
        </ColSpan>
      </RowSpan>
      <RowSpan>
        <ColSpan
          span="3"
        >
          <FItem
            :module="module.getItem('payedForAgreement')"
          />
        </ColSpan>
        <ColSpan
          span="3"
        >
          <FItem
            :module="module.getItem('debtForAgreement')"
          />
        </ColSpan>
        <ColSpan
          span="3"
        >
          <div class="f-item__label"></div>
          <FBtn style="padding-top: 5px">
            <BtnPrimary
              @click="$emit('submit')"
            >
              Найти
            </BtnPrimary>
          </FBtn>

        </ColSpan>
      </RowSpan>
    </FBody>
  </div>
</template>
<style lang="scss">
.tour-list-form {
  .btn-primary {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 1px solid #dcdfe6;
    border-color: #dcdfe6;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: none;
    margin: 0;
    -webkit-transition: .1s;
    transition: .1s;
    font-weight: 500;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    font-size: 14px;
    border-radius: 4px;
    color: #fff;
    background-color: #6db234;
    border-color: #6db234;
    padding: 9px 15px;
    font-size: 12px;
    border-radius: 3px;
    width: 100%;
    height: 32px;
  }

  .f-item {
    padding: 0px 0px 8px 0px;
  }
  .f-item__label {
    position: relative;
    top: 0px;
    width: 100%;
    -webkit-transition: 0.1s ease-out;
    transition: 0.1s ease-out;
    line-height: 24px;
    font-size: 16px;
    padding-left: 2px;
    font-size: 14px;
    min-height: 18px;
    padding-top: 0px;
    font-weight: 500;
  }

  .el-input__inner,
  .f-c-input{
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 32px;
    line-height: 32px;
    outline: none;
    padding: 0 15px;
    -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
    transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
    width: 100%;
  }
  .el-date-editor{
    display: flex;
    .el-input__inner{
      width: 39%;
    }
  }
  .f-item__body:after {
    height: 0px;
  }
  .f-item__body:before {
    height: 0px;
  }
  .el-select{
    .el-input__inner{
      height:32px !important;
      background-color: #fff!important;
      border: none;
    }
    .el-input__suffix {
      cursor: pointer;
      position: static;
      display: block;
      height: 32px;
      border-radius: 50%;
      width: 32px;
    }
    &.f-c-select{
      height: 32px!important;
      .el-input{
        height: 32px!important;
        background: #fff;
        border-radius: 4px;
      }
    }
    .el-input.is-focus{
      .el-input__inner{
        background-color: #fff!important;
        height: 32px!important;
      }
    }
  }
}
  @media (max-width: 1000px) {
    .p-t-c-lf {
      .col-span--3 {
        width: 50%;
      }
    }
  }
  @media (max-width: 500px) {
    .p-t-c-lf {
      .col-span--3 {
        width: 100%;
      }
    }
  }
</style>
